import { createGenericTemporaryFormStore } from './factories/genericTemporaryStore';
import { JobFormData } from '@/jobs/application/types/JobTypes';

export const useJobTemporaryFormStore = createGenericTemporaryFormStore<JobFormData>('JobTemporaryFormStore');
